import Backdraft from "backdraft-app/src/backdraft";

import "./src/app";
import "./src/views/file_upload_dropzone";

const FileUploadDropzone = Backdraft.app("Shared/FileUpload").Views.FileUploadDropzone;

export default FileUploadDropzone;
